/* src/app/modules/user/components/admin-users/admin-users.component.scss */
.btnusr {
  background-color: #073b70;
}
/*# sourceMappingURL=admin-users.component.css.map */
